import { makeObservable, observable, toJS } from 'mobx';
import { CodeIndex, CodeList } from './types';
import { CodelistClient } from './codelist-client';

class CodelistStore {
    codelist: CodeList | null = null;
    codeIndex: CodeIndex = new Map();

    constructor() {
        makeObservable(this, {
            codelist: observable,
            codeIndex: observable,
        });

        this.initCodelist();
    }

    private async initCodelist() {
        const codelist: CodeList | null = await CodelistClient.getCodelistForProject();
        if (!codelist) {
            console.warn('No codelist found for the current project.');
            return;
        }

        this.codelist = codelist;
        this.buildCodeIndex();
        console.log('Codelist Index built with', this.codeIndex.size, 'entries.', toJS(this.codeIndex));
    }

    private buildCodeIndex() {
        if (!this.codelist) {
            this.codeIndex = new Map();
            return;
        }

        const index: CodeIndex = new Map();
        this.codelist.codes.filter(code => code.name !== undefined && code.name !== null).forEach(code => index.set(code.name, code));

        this.codeIndex = index;
    }

    public getCodeByName(codeName: string) {
        return this.codeIndex.get(codeName) || null;
    }
}

export const codelistStore = new CodelistStore();
